<template>
    <button
        type="button"
        role="switch"
        dir="ltr"
        :aria-checked="modelValue"
        :disabled="disabled"
        @click="toggle"
        class="relative inline-flex h-6 w-11 flex-shrink-0 self-center cursor-pointer overflow-hidden rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
        :class="modelValue ? 'bg-blue-600' : 'bg-slate-200'"
    >
        <span class="sr-only">{{ $t('common.components.toggle_sr_only') }}</span>
        <span
            aria-hidden="true"
            class="pointer-events-none absolute top-1/2 -translate-y-1/2 inline-block h-5 w-5 rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out"
            :class="modelValue ? 'left-[calc(100%-1.375rem)]' : 'left-0.5'"
        />
    </button>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'TToggle',
    
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    
    emits: ['update:modelValue'],
    
    methods: {
        toggle() {
            if (!this.disabled) {
                this.$emit('update:modelValue', !this.modelValue);
            }
        }
    }
});
</script>
